import React from "react";
const LoginFailure = () => {
    console.log('LoginFailure')
	//todo: add required desgin here, 
    return <div>Login Failure</div>
}
export default LoginFailure;